import React from "react";
import { CopyPill } from "./CopyPill";
import { Modal } from "./Modal";
import { Button, Segmented } from "../design";
import { cliUrl } from "../lib/urls";
import { detectPlatform, type Platform } from "../lib/platform";

export function InstallPicker({
  seen,
  onSeen,
}: {
  seen: boolean;
  onSeen: () => void;
}) {
  const [os, setOs] = React.useState<Platform>(() => detectPlatform());
  const [showExplainer, setShowExplainer] = React.useState(false);
  const base = cliUrl();

  const cfg =
    os === "windows"
      ? {
          command: `irm ${base}/nt | iex`,
          host: `${base}/nt`,
          prompt: "PS>",
        }
      : {
          command: `curl -fsSL ${base}/unix | sh`,
          host: `${base}/unix`,
          prompt: "$",
        };

  const onCopied = React.useCallback(() => {
    if (seen) return;
    setShowExplainer(true);
    onSeen();
  }, [seen, onSeen]);

  return (
    <div className="install-picker per-install">
      <Segmented
        size="sm"
        label="Operating system"
        toggle
        value={os}
        onChange={setOs}
        options={[
          { value: "unix", label: "Mac / Linux" },
          { value: "windows", label: "Windows" },
        ]}
      />
      <CopyPill
        command={cfg.command}
        host={cfg.host}
        prompt={cfg.prompt}
        onCopied={onCopied}
      />
      {showExplainer && (
        <Modal
          title="Command copied"
          onClose={() => setShowExplainer(false)}
          footer={
            <Button variant="primary" onClick={() => setShowExplainer(false)}>
              Got it
            </Button>
          }
        >
          <p className="install-lead">
            <strong>
              Keep using <span className="mono">claude</span> exactly as before.
            </strong>{" "}
            Every session’s savings land right here on your dashboard — you only
            set this up once.
          </p>
          <div className="install-steps">
            <div className="install-step">
              <span className="mono install-step-num">01</span>
              <span>Paste the command into your terminal and run it.</span>
            </div>
            <div className="install-step">
              <span className="mono install-step-num">02</span>
              <span>
                When <span className="mono">dense</span> offers to route{" "}
                <span className="mono">claude</span> through condense, accept.
              </span>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
